export default {
  label: "In Entwicklung",
  notAvailable: "nicht verfügbar",
};
